module.exports = __webpack_public_path__ + "media/images/athletes/3599-952c249af6166f6ad3ecd81489b9fff7.png";